import React, { useState, useContext } from 'react';
import './home.css';
import { UserContext } from '../context/UserContext';

export default function Jobs() {
  const { user } = useContext(UserContext);
  const [openFaq, setOpenFaq] = useState(null);
  const faqs = [
    { q: 'Muss ich schon Erfahrung haben?', a: 'Nicht zwingend – Motivation, Lernbereitschaft und Verlässlichkeit sind wichtiger.' },
    { q: 'Wird etwas bezahlt?', a: 'Viele Rollen starten ehrenamtlich. Perspektivisch möglich: Vergütungen oder Vorteile je nach Beitrag & Struktur.' },
    { q: 'Wie viel Zeit sollte ich einplanen?', a: 'Je nach Rolle 2–6 Stunden pro Woche. Wir stimmen das individuell ab.' },
    { q: 'Kann ich mehrere Bereiche kombinieren?', a: 'Ja – wenn es sinnvoll bleibt und du dich nicht überlastest.' },
    { q: 'Kann ich wieder aufhören?', a: 'Ja, bitte nur frühzeitig signalisieren damit wir sauber übergeben.' },
  ];
  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Jobs beim AP‑Network</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>
          Werde Teil unseres kuratierten Netzwerks und gestalte aktiv mit. Wir suchen engagierte Menschen, die
          mit Leidenschaft, Verlässlichkeit und Kreativität unsere Vision unterstützen.
        </p>
      </section>
      {/* Content */}
      <section style={{ width: '100%', maxWidth: 1100, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Warum AP-N als "Arbeits" / Engagement-Umfeld */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Warum das AP‑Network?</h2>
          <p className="highlight-desc" style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <span aria-hidden="true" style={{fontSize:22}}>🚀</span>
            <span>
              Wir kombinieren die Struktur einer modernen Organisation mit der Energie einer kreativen Community.
              Bei uns zählt <b>Qualität vor Quantität</b> – echte Zusammenarbeit statt flüchtiger Hypes.
            </span>
          </p>
        </div>

        {/* Rollenarten Übersicht */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Rollen & Bereiche</h2>
          <p className="highlight-desc" style={{ marginBottom: 12 }}>
            Wir bieten verschiedene Möglichkeiten dich einzubringen – teils ehrenamtlich, teils perspektivisch vergütet.
          </p>
          <ul style={{ listStyle:'none', margin:0, padding:0, display:'grid', gap:14 }}>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🛡️</span><span><b>Moderation / Community Care</b> – Sicherstellen von Fairness, Positivität und Einhaltung von Regeln.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🧪</span><span><b>Quality & Review</b> – Hilft bei Feedback, Verbesserungen und Content‑Standards.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🛠️</span><span><b>Technik & Entwicklung</b> – Unterstützung bei Webapp, Bots, Automationen, Integrationen.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🤝</span><span><b>Mentoring & Coaching</b> – Unterstützung von Creator:innen bei Wachstum & Struktur.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🎨</span><span><b>Design & Media</b> – Grafiken, Thumbnails, Branding‑Elemente und visuelle Konzepte.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>📣</span><span><b>Kommunikation / Social</b> – Posts, interne Rundmails, Öffentlichkeitsarbeit & Klarheit.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>📅</span><span><b>Events & Formate</b> – Planung und Durchführung von Aktionen & Kooperationen.</span></li>
          </ul>
        </div>

        {/* Was wir bieten */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Was wir bieten</h2>
          <ul style={{ listStyle:'none', margin:0, padding:0, display:'grid', gap:10 }}>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🎯</span><span><b>Klare Mission</b> – Fokus auf nachhaltigem Wachstum, Fairness und Wertschätzung.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>📊</span><span><b>Struktur & Transparenz</b> – Definierte Prozesse statt Chaos & willkürlicher Entscheidungen.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🤗</span><span><b>Teamgeist</b> – Offener Austausch, konstruktives Feedback & respektvolles Miteinander.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>📚</span><span><b>Lernen & Entwicklung</b> – Zugang zu Know‑how, internen Tools & Erfahrungswissen.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🛠️</span><span><b>Professionelle Tools</b> – Einbindung in unsere wachsende Webplattform & Automationen.</span></li>
          </ul>
        </div>

        {/* Offene Positionen Placeholder */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Aktuell offene Positionen</h2>
          <p className="highlight-desc" style={{ marginBottom: 10 }}>
            Hier listen wir konkrete Rollen/Jobs, für die wir aktiv Unterstützung suchen. Teilweise direkt für das AP-Network, teilweise aber auch direkt für einzelne Creator.
          </p>
          <div style={{ display:'grid', gap:14 }}>
            {[
              /*{ title:'Community Moderator:in', emoji:'🛡️', desc:'Hilf dabei Chat‑ & Plattformbereiche konstruktiv zu halten.' }*/,
              /*{ title:'Event Koordination (Assistenz)', emoji:'📅', desc:'Unterstütze Planung, Ablauf und Nachbereitung von Aktionen.' }*/,
              { title:'Mentor:in', emoji:'🤝', desc:'Begleite Creator beim Strukturieren erster Schritte & Ziele.' },
              /*{ title:'Frontend Developer (React)', emoji:'🛠️', desc:'Arbeite an Komponenten, UI/UX und Tool‑Flows.' }*/,
              { title:'Grafik / Media Support', emoji:'🎨', desc:'Erstelle Thumbnails, Layer, Visuals & Brandingpieces.' },
              { title:'Cutter / Audio- & Videoschnitt', emoji:'🎥', desc:'Schneide Shorts, Reels, Clips & ganze Videos.' },
            ].map((job,i) => (
              <div key={i} style={{ border:'1px solid rgba(255,255,255,0.08)', padding:16, borderRadius:10, background:'rgba(255,255,255,0.03)' }}>
                <div style={{ fontWeight:600, display:'flex', alignItems:'center', gap:8 }}><span style={{fontSize:20}}>{job.emoji}</span>{job.title}</div>
                <div style={{ fontSize:13, color:'#cbd5e1', marginTop:4 }}>{job.desc}</div>
                <div style={{ marginTop:10 }}>
                  <a href="/kontakt" className="hero-btn-secondary" style={{ padding:'8px 12px', textDecoration:'none' }}>Interesse melden</a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bewerbungsprozess */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Ablauf deiner Bewerbung / Mitarbeit</h2>
          <ol style={{ margin:0, padding:'0 0 0 20px', display:'grid', gap:8 }}>
            <li><b>Interesse bekunden:</b> Kurze Nachricht über Kontaktformular / DM.</li>
            <li><b>Erstgespräch:</b> Erwartungen, zeitliche Möglichkeiten & Motivation klären.</li>
            <li><b>Testphase:</b> Kleine Aufgaben / Begleitung, um Zusammenarbeit zu prüfen.</li>
            <li><b>Onboarding:</b> Zugriff auf relevante Bereiche, Tools & Guidelines.</li>
            <li><b>Regelmäßiger Austausch:</b> Feedback‑Runden, Retros & Verbesserungsloopen.</li>
          </ol>
        </div>

        {/* Grundsätze */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Grundsätze unserer Zusammenarbeit</h2>
          <ul style={{ listStyle:'none', margin:0, padding:0, display:'grid', gap:10 }}>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>⚖️</span><span><b>Fairness</b> – Klare Regeln & gleiche Standards für alle.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>💬</span><span><b>Transparenz</b> – Offene Kommunikation über Status, Entscheidungen & Änderungen.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🧠</span><span><b>Lernen</b> – Ständige Verbesserungen von Prozessen & Formaten.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>⏱️</span><span><b>Verbindlichkeit</b> – Zusagen ernst nehmen, frühzeitig Engpässe signalisieren.</span></li>
            <li style={{ display:'flex', gap:10 }}><span aria-hidden style={{fontSize:20}}>🌱</span><span><b>Nachhaltigkeit</b> – Kein künstlicher Stress, Fokus auf gesunde Entwicklung.</span></li>
          </ul>
        </div>

        {/* FAQ */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">FAQ (Kurz)</h2>
          <div style={{ display: 'grid', gap: 12, width: '100%' }}>
            {faqs.map((item, i) => {
              const open = openFaq === i;
              const panelId = `jobs-faq-${i}`;
              return (
                <div
                  key={i}
                  style={{
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: 10,
                    background: 'rgba(255,255,255,0.03)',
                    width: '100%'
                  }}
                >
                  <button
                    onClick={() => setOpenFaq(open ? null : i)}
                    aria-expanded={open}
                    aria-controls={panelId}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                      background: 'transparent',
                      color: '#E2E5EA',
                      fontWeight: 600,
                      padding: '12px 14px',
                      paddingRight: 38,
                      border: 'none',
                      textAlign: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <span style={{ display: 'block', width: '100%', textAlign: 'center' }}>{item.q}</span>
                    <span aria-hidden="true" style={{ opacity: 0.85, position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}>
                      {open ? '−' : '+'}
                    </span>
                  </button>
                  {open && (
                    <div id={panelId} style={{ padding: '0 14px 12px 14px', color: '#cbd5e1', lineHeight: 1.6 }}>
                      <p style={{ margin: 0, fontSize: 13 }}>{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Bereit dich einzubringen?</h2>
            <p className="highlight-desc" style={{ marginBottom: 12 }}>
              Sende uns eine kurze Nachricht mit deinen Interessen und Möglichkeiten – wir melden uns bei dir.
            </p>
          <div style={{ display:'flex', gap: 8, flexWrap:'wrap' }}>
            <a className="hero-btn-primary" href="/kontakt" style={{ padding: '12px 18px', textDecoration:'none' }}>Kontakt aufnehmen</a>
            <a className="hero-btn-secondary" href="/register" style={{ padding: '12px 18px', textDecoration:'none' }}>Jetzt beitreten</a>
          </div>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}
